const CheckSelection = (cstate, { id }) => {
  const { current, states } = cstate;

  if (current.id === id) {
    const next = states
      .filter(s => s.id !== current.id)
      .filter(ic => ic.incorrect === false)
      .filter(corr => corr.correct === 0)[0];
    if (current.incorrect) {
      const halfCorrect = { ...current, className: 'halfcorrect' };
      const newStates = [...states.filter(n => n.id !== current.id), halfCorrect];
      return {
        ...cstate,
        current: next,
        states: newStates,
        correct: newStates.filter(f => f.correct === 1).length,
      };
    }
    const correctState = { ...current, correct: 1, className: 'correct' };
    const newStates = [...states.filter(n => n.id !== current.id), correctState];
    return {
      ...cstate,
      current: next,
      states: newStates,
      correct: newStates.filter(f => f.correct === 1).length,
    };
  }

  if (current.id !== id) {
    if (current.misses >= 2) {
      const fillRed = { ...current, className: 'incorrect', incorrect: true };
      const redIncorrect = [...states.filter(i => i.id !== current.id), fillRed];
      const nextAfterMiss = states.filter(s => s.id !== current.id)[0];
      return {
        ...cstate,
        current: nextAfterMiss,
        states: redIncorrect,
        incorrect: redIncorrect.filter(rf => rf.incorrect === true).length,
      };
    }

    const incrementCurrentMisses = { ...current, misses: current.misses + 1, incorrect: true };
    const replaceIncorrect = [...states.filter(i => i.id !== current.id), incrementCurrentMisses];
    return {
      ...cstate,
      current: incrementCurrentMisses,
      states: replaceIncorrect,
      incorrect: replaceIncorrect.filter(inc => inc.incorrect === true).length,
    };
  }
  return cstate;
};

export { CheckSelection };
export default CheckSelection;



// WEBPACK FOOTER //
// ./src/reducers/helpers/checks.js